import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  suffix: {
    id: 'person.suffix',
    defaultMessage: 'Suffix',
  },
  employment: {
    id: 'person.employment',
    defaultMessage: 'Employment',
  },
  jobTitle: {
    id: 'person.job_title',
    defaultMessage: 'Job title',
  },
  portraitAlt: {
    id: 'person.portrait_alt',
    defaultMessage: 'Portrait of {name}',
  },
});

/**
 * PersonHeader component class.
 * @function PersonHeader
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const PersonHeader = ({ content, showPortrait }) => {
  showPortrait = showPortrait || false;
  const Image = config.getComponent({ name: 'Image' }).component;
  return (
    <div className="person-header">
      <div className="person-text-image-wrapper">
        <div className="person-text">
          {content?.taxonomy_academic_degree && (
            <div className="person-suffix-heading">
              {content?.taxonomy_academic_degree
                .map((ad) => ad.title)
                .join(', ')}
            </div>
          )}
          <h1 className="documentFirstHeading person-name-heading">
            {content.name} {content.middlename} {content.familyname}
          </h1>
          {content?.employment &&
            content.employment.map((emp, idx) =>
              emp ? (
                <p key={idx} className="person-employment">
                  {emp}
                </p>
              ) : null,
            )}
          {content?.job_title?.[0] &&
            content.job_title.map((jt, idx) =>
              jt ? (
                <p key={idx} className="person-employment">
                  {jt}
                </p>
              ) : null,
            )}
        </div>
        {showPortrait && content?.image?.download && (
          <div className="person-portrait">
            <a href={flattenToAppURL(content.image.download)}>
              <Image
                item={content}
                imageField="image"
                alt={content.title}
                responsive={true}
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
PersonHeader.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    portrait: PropTypes.shape({
      scales: PropTypes.shape({
        preview: PropTypes.shape({
          download: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default PersonHeader;
